function intakeYearFromOption(option) {
  if (!option) return 0;
  if (option.year != null && String(option.year).trim() !== "") {
    const parsed = parseInt(String(option.year), 10);
    if (!Number.isNaN(parsed)) return parsed;
  }
  const text = String(option.label ?? option.title ?? "");
  const match = text.match(/\b(20\d{2})\b/);
  return match ? parseInt(match[1], 10) : 0;
}

function intakeQuarterFromOption(option) {
  const fromField = option?.quarter;
  if (fromField) {
    const match = String(fromField).match(/Q?([1-4])\b/i);
    if (match) return parseInt(match[1], 10);
  }
  const text = String(option.label ?? option.title ?? "");
  const match = text.match(/\bQ([1-4])\b/i);
  return match ? parseInt(match[1], 10) : 0;
}

/**
 * All intakes for Add/Edit Course, ordered newest year first:
 * 2027 → 2026 → 2025 … (within a year: Q1 → Q4).
 */
export function getCourseFormIntakeOptions(options = []) {
  if (!Array.isArray(options)) return [];
  return [...options].sort((a, b) => {
    const yearDiff = intakeYearFromOption(b) - intakeYearFromOption(a);
    if (yearDiff !== 0) return yearDiff;
    const quarterDiff =
      intakeQuarterFromOption(a) - intakeQuarterFromOption(b);
    if (quarterDiff !== 0) return quarterDiff;
    return String(a?.label ?? "").localeCompare(String(b?.label ?? ""));
  });
}
